import { lazy } from "react"

export const FineChargesList = lazy(() => import("./fineCharges/FineChargesList"))
export const FineChargesDetails = lazy(() => import("./fineCharges/FineChargesDetails"))
export const DuesAndPayments = lazy(() => import("./dues_payments/DuesAndPayments"))
export const InvoiceList = lazy(() => import("./invoice/InvoiceList"))
export const PaymentList = lazy(() => import("./payment/PaymentList"))
export const PaymentDetails = lazy(() => import("./payment/PaymentDetails"))
export const ExpenseBudget = lazy(() => import("./expenseBudget/ExpenseBudget"))
export const BudgetTrackingList = lazy(() => import("./budgetTracking/BudgetTrackingList"))
export const ExpenseList = lazy(() => import("./expense/ExpenseList"))
export const ExpenseDetails = lazy(() => import("./expense/ExpenseDetails"))
export const Finance = lazy(() => import("./admin_finance/Finance"))